import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TransitionAlerts from './TransitionAlerts';
import ClientProvider from './client';
export default createDemo(import.meta.url, TransitionAlerts, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/alert/demos/transition/TransitionAlerts.tsx",
    "fileName": "TransitionAlerts.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Alert from '@mui/material/Alert';\nimport IconButton from '@mui/material/IconButton';\nimport Collapse from '@mui/material/Collapse';\nimport Button from '@mui/material/Button';\nimport CloseIcon from '@mui/icons-material/Close';\n\nexport default function TransitionAlerts() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [open, setOpen] = React.useState(true);\n\n  return (\n    <Box sx={{ width: '100%' }}>\n      <Collapse in={open}>\n        <Alert\n          action={\n            <IconButton\n              aria-label=\"close\"\n              color=\"inherit\"\n              size=\"small\"\n              onClick={() => {\n                setOpen(false);\n              }}\n            >\n              <CloseIcon fontSize=\"inherit\" />\n            </IconButton>\n          }\n          sx={{ mb: 2 }}\n        >\n          Click the close icon to see the Collapse transition in action!\n        </Alert>\n      </Collapse>\n      <Button\n        disabled={open}\n        variant=\"outlined\"\n        onClick={() => {\n          setOpen(true);\n        }}\n      >\n        Re-open\n      </Button>\n    </Box>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 44,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Alert from '@mui/material/Alert';\nimport IconButton from '@mui/material/IconButton';\nimport Collapse from '@mui/material/Collapse';\nimport Button from '@mui/material/Button';\nimport CloseIcon from '@mui/icons-material/Close';\n\nexport default function TransitionAlerts() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [open, setOpen] = React.useState(true);\n\n  return (\n    <Box sx={{ width: '100%' }}>\n      <Collapse in={open}>\n        <Alert\n          action={\n            <IconButton\n              aria-label=\"close\"\n              color=\"inherit\"\n              size=\"small\"\n              onClick={() => {\n                setOpen(false);\n              }}\n            >\n              <CloseIcon fontSize=\"inherit\" />\n            </IconButton>\n          }\n          sx={{ mb: 2 }}\n        >\n          Click the close icon to see the Collapse transition in action!\n        </Alert>\n      </Collapse>\n      <Button\n        disabled={open}\n        variant=\"outlined\"\n        onClick={() => {\n          setOpen(true);\n        }}\n      >\n        Re-open\n      </Button>\n    </Box>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 44,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Alert",
      "@mui/material/IconButton",
      "@mui/material/Collapse",
      "@mui/material/Button",
      "@mui/icons-material/Close"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
